(function () {
  'use strict';

  function toNumber(value) {
    var parsed = window.parseFloat(value || '0');
    return window.isNaN(parsed) ? 0 : parsed;
  }

  function getGap(track) {
    if (!window.getComputedStyle) return 0;
    var styles = window.getComputedStyle(track);
    return toNumber(styles.columnGap || styles.gap || '0');
  }

  function getStep(track) {
    var card = track && track.querySelector ? track.querySelector('.snl-home-product') : null;
    if (!card) return 320;
    return card.getBoundingClientRect().width + getGap(track);
  }

  function getFullCount(track) {
    if (!window.getComputedStyle) return 3;
    var value = window.getComputedStyle(track).getPropertyValue('--snl-slider-full');
    var parsed = Math.round(toNumber(value || '3'));
    return parsed > 0 ? parsed : 3;
  }

  function getPeek(track) {
    var card = track && track.querySelector ? track.querySelector('.snl-home-product') : null;
    if (card) {
      var cardWidth = card.getBoundingClientRect().width;
      var fullCount = getFullCount(track);
      var calculated = (track.clientWidth - (cardWidth * fullCount) - (getGap(track) * (fullCount + 1))) / 2;
      if (calculated > 0) return calculated;
    }
    if (!window.getComputedStyle) return 72;
    var value = window.getComputedStyle(track).getPropertyValue('--snl-slider-peek');
    var parsed = toNumber(value || '72');
    return parsed > 0 ? parsed : 72;
  }

  function getTrack(button) {
    var section = button && button.closest ? button.closest('.snl-home-slider') : null;
    return section ? section.querySelector('[data-snl-home-track]') : null;
  }

  function scrollTrack(track, delta) {
    if (!track) return;
    if (track.scrollBy) {
      track.scrollBy({ left: delta, behavior: 'smooth' });
      return;
    }
    track.scrollLeft += delta;
  }

  function setTrackLeft(track, left, behavior) {
    if (!track) return;
    if (track.scrollTo) {
      track.scrollTo({ left: left, behavior: behavior || 'auto' });
      return;
    }
    try {
      track.scrollLeft = left;
    } catch (error) {}
  }

  function setTrackLeftNow(track, left) {
    if (!track) return;
    try {
      track.scrollLeft = left;
    } catch (error) {
      setTrackLeft(track, left, 'auto');
    }
  }

  function slide(button, direction) {
    var track = getTrack(button);
    if (!track) return false;
    scrollTrack(track, getStep(track) * direction);
    return false;
  }

  function snapTrack(track) {
    if (!track) return;
    var step = getStep(track);
    if (!step || step <= 0) return;

    var offset = -getPeek(track) - getGap(track);
    var target = Math.round((track.scrollLeft - offset) / step) * step + offset;
    var max = track.scrollWidth - track.clientWidth;

    if (target < 0) target = 0;
    if (target > max) target = max;

    setTrackLeft(track, target, 'smooth');
  }

  function bindControls(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var buttons = root.querySelectorAll('[data-snl-home-prev], [data-snl-home-next]');
    for (var i = 0; i < buttons.length; i += 1) {
      if (buttons[i].getAttribute('data-snl-bound') === 'true') continue;
      buttons[i].setAttribute('data-snl-bound', 'true');
      buttons[i].addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        slide(this, this.hasAttribute('data-snl-home-prev') ? -1 : 1);
      });
    }
  }

  function normalizeLoop(track) {
    if (!track || track.getAttribute('data-snl-loop-ready') === 'true') return;
    track.setAttribute('data-snl-loop-ready', 'true');

    var copies = parseInt(track.getAttribute('data-snl-loop-copies') || '3', 10);
    if (!copies || copies < 2) copies = 3;

    function copyWidth() {
      return track.scrollWidth / copies;
    }

    function startPosition() {
      return copyWidth() - getPeek(track) - getGap(track);
    }

    function placeInMiddle() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) return;
      setTrackLeft(track, startPosition(), 'auto');
    }

    window.setTimeout(placeInMiddle, 60);
    window.setTimeout(placeInMiddle, 600);

    track.addEventListener('scroll', function () {
      var limit = track.scrollWidth - track.clientWidth;
      if (limit <= 0) return;
      var width = copyWidth();
      var step = getStep(track);

      if (track.scrollLeft < width - (step * 2)) {
        setTrackLeft(track, track.scrollLeft + width, 'auto');
      } else if (track.scrollLeft > (width * 2) - track.clientWidth + (step * 2)) {
        setTrackLeft(track, track.scrollLeft - width, 'auto');
      }
    }, { passive: true });

    window.addEventListener('resize', function () {
      window.clearTimeout(track._snlResizeTimer);
      track._snlResizeTimer = window.setTimeout(placeInMiddle, 150);
    });
  }

  function bindDrag(track) {
    if (!track || track.getAttribute('data-snl-drag-ready') === 'true') return;
    track.setAttribute('data-snl-drag-ready', 'true');

    var surface = track.closest && track.closest('.snl-home-slider__viewport') ? track.closest('.snl-home-slider__viewport') : track;
    var isDown = false;
    var hasMoved = false;
    var clickShouldBeBlocked = false;
    var startX = 0;
    var startY = 0;
    var startLeft = 0;
    var activeInput = '';
    var ignoreMouseUntil = 0;

    function readX(event) {
      if (event.touches && event.touches.length) return event.touches[0].clientX;
      if (event.changedTouches && event.changedTouches.length) return event.changedTouches[0].clientX;
      return event.clientX || 0;
    }

    function readY(event) {
      if (event.touches && event.touches.length) return event.touches[0].clientY;
      if (event.changedTouches && event.changedTouches.length) return event.changedTouches[0].clientY;
      return event.clientY || 0;
    }

    // Arrow buttons share the drag surface with product links. They must keep
    // their own click handler and must never trigger coordinate-based navigation.
    function isControl(event) {
      return event.target && event.target.closest &&
        event.target.closest('button, [role="button"], input, select, textarea, summary');
    }

    function startDrag(event) {
      // iOS synthesizes mouse events after touch. They must not restart a drag
      // or disable a link between touchend and the native click.
      if (event.type.indexOf('mouse') === 0 && Date.now() < ignoreMouseUntil) return;
      if (event.type.indexOf('touch') === 0) ignoreMouseUntil = Date.now() + 800;
      if (isControl(event)) {
        hasMoved = false;
        clickShouldBeBlocked = false;
        return;
      }
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      if (activeInput && activeInput !== event.type.replace(/down|start/i, '')) return;
      if (event.button !== undefined && event.button !== 0) return;
      isDown = true;
      hasMoved = false;
      clickShouldBeBlocked = false;
      activeInput = event.type.indexOf('touch') === 0 ? 'touch' : (event.type.indexOf('mouse') === 0 ? 'mouse' : 'pointer');
      startX = readX(event);
      startY = readY(event);
      startLeft = track.scrollLeft;
    }

    function moveDrag(event) {
      if (!isDown) return;
      if (activeInput === 'touch' && event.type.indexOf('touch') !== 0) return;
      if (activeInput === 'pointer' && event.type.indexOf('pointer') !== 0) return;
      if (activeInput === 'mouse' && event.type.indexOf('mouse') !== 0) return;
      var delta = readX(event) - startX;
      var deltaY = readY(event) - startY;
      if (!hasMoved && Math.abs(deltaY) > Math.abs(delta) + 8) {
        endDrag(event);
        return;
      }
      if (Math.abs(delta) > 6 && Math.abs(delta) >= Math.abs(deltaY)) {
        if (!hasMoved) {
          track.classList.add('is-dragging');
          if (surface.setPointerCapture && event.pointerId !== undefined) {
            try { surface.setPointerCapture(event.pointerId); } catch (error) {}
          }
        }
        hasMoved = true;
        clickShouldBeBlocked = true;
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
      }
      if (hasMoved) setTrackLeftNow(track, startLeft - delta);
    }

    function endDrag(event) {
      if (!isDown) return;
      isDown = false;
      activeInput = '';
      track.classList.remove('is-dragging');
      if (surface.releasePointerCapture && event && event.pointerId) {
        try { surface.releasePointerCapture(event.pointerId); } catch (error) {}
      }
      if (hasMoved) {
        window.setTimeout(function () {
          snapTrack(track);
        }, 0);
      }
    }

    function findAnchorAtPoint(x, y) {
      var anchors = track.querySelectorAll('.snl-home-swatch[href], .snl-home-product__media[href], .snl-home-product__title[href], .snl-home-product__price[href]');
      for (var i = anchors.length - 1; i >= 0; i -= 1) {
        var anchor = anchors[i];
        var rect = anchor.getBoundingClientRect();
        var styles = window.getComputedStyle ? window.getComputedStyle(anchor) : null;
        if (styles && (styles.visibility === 'hidden' || styles.display === 'none' || styles.pointerEvents === 'none')) continue;
        if (rect.width <= 0 || rect.height <= 0) continue;
        if (x >= rect.left - 6 && x <= rect.right + 6 && y >= rect.top - 6 && y <= rect.bottom + 6) {
          return anchor;
        }
      }
      return null;
    }

    var hasTouch = ('ontouchstart' in window) || (window.navigator && window.navigator.maxTouchPoints > 0);

    if (window.PointerEvent && !hasTouch) {
      surface.addEventListener('pointerdown', startDrag, { passive: true });
      surface.addEventListener('pointermove', moveDrag, { passive: false });
      surface.addEventListener('pointerup', endDrag, { passive: true });
      surface.addEventListener('pointercancel', endDrag, { passive: true });
      surface.addEventListener('pointerleave', endDrag, { passive: true });
    } else {
      surface.addEventListener('touchstart', startDrag, { passive: true });
      surface.addEventListener('touchmove', moveDrag, { passive: false });
      surface.addEventListener('touchend', endDrag, { passive: true });
      surface.addEventListener('touchcancel', endDrag, { passive: true });
      surface.addEventListener('mousedown', startDrag);
      window.addEventListener('mousemove', moveDrag);
      window.addEventListener('mouseup', endDrag);
    }

    surface.addEventListener('click', function (event) {
      if (isControl(event)) {
        hasMoved = false;
        clickShouldBeBlocked = false;
        return;
      }
      if (event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
      if (!clickShouldBeBlocked) {
        if (event.target && event.target.closest && event.target.closest('a[href]')) return;
        var fallbackAnchor = findAnchorAtPoint(event.clientX || 0, event.clientY || 0);
        if (!fallbackAnchor) return;
        event.preventDefault();
        event.stopPropagation();
        window.location.href = fallbackAnchor.href;
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      hasMoved = false;
      clickShouldBeBlocked = false;
    }, true);

    var draggableItems = track.querySelectorAll('a, img');
    for (var i = 0; i < draggableItems.length; i += 1) {
      draggableItems[i].setAttribute('draggable', 'false');
    }
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    bindControls(root);

    var tracks = root.querySelectorAll('[data-snl-home-track]');
    for (var i = 0; i < tracks.length; i += 1) {
      normalizeLoop(tracks[i]);
      bindDrag(tracks[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
